import markericonSit1 from "../../assets/img/maps/Site-maps-gris.png";
import markericonSit2 from "../../assets/img/maps/Site-maps-vert.png";
import markericonGroup1 from "../../assets/img/maps/Groupe-maps-gris.png";
import markericonGroup2 from "../../assets/img/maps/Groupe-maps-vert.png";
import markericonFeu1 from "../../assets/img/maps/Feu-maps-gris.png";
import markericonFeu2 from "../../assets/img/maps/Feu-maps-vert.png";
import markericonBat1 from "../../assets/img/maps/Batiment-maps-gris.png";
import markericonBat2 from "../../assets/img/maps/Batiment-maps-vert.png";
import markeractiomapsvert from "../../assets/img/maps/Action-maps-vert.png";
import markergatewayvert from "../../assets/img/maps/Gateway-maps-vert.png";
import markergatewayorange from "../../assets/img/maps/Gateway-maps-orange.png";
import markergatewaygris from "../../assets/img/maps/Gateway-maps-gris.png";

export const optionsData = [
  {
    name: "Sites", id: "1", unselectedicon: markericonSit1, selectedicon: markericonSit2
  },
  {
    name: "Groupes", id: "0", unselectedicon: markericonGroup1, selectedicon: markericonGroup2
  },
  {
    name: "Bâtiments", id: "2_0", unselectedicon: markericonBat1, selectedicon: markericonBat2
  },
  {
    name: "Equipements urbains", id: "2_1", unselectedicon: markericonFeu1, selectedicon: markericonFeu2
  },
  {
    name: "Compteurs", id: "meters"
  },
];

export const optionsMBMData = [
  {
    name: "Sites", id: "1", unselectedicon: markericonSit1, selectedicon: markericonSit2
  },
  {
    name: "Groupes", id: "0", unselectedicon: markericonGroup1, selectedicon: markericonGroup2
  },
  {
    name: "Bâtiments", id: "2_0", unselectedicon: markericonBat1, selectedicon: markericonBat2
  },
  {
    name: "Equipements urbains", id: "2_1", unselectedicon: markericonFeu1, selectedicon: markericonFeu2
  },
  {
    name: "Compteurs", id: "meters"
  },
  // {
  //   name: "Passerelles LoRaWAN", id: "10", unselectedicon: markergatewaygris, selectedicon: markeractiomapsvert, statusok: markergatewayvert, statusko: markergatewayorange, statusunknown: markergatewaygris
  // },
  {
    name: "Passerelles LoRaWAN", id: "10"
  }
];
